import { render, staticRenderFns } from "./CustomerCreateForm.vue?vue&type=template&id=0358f4e4&"
import script from "./CustomerCreateForm.vue?vue&type=script&lang=js&"
export * from "./CustomerCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0358f4e4')) {
      api.createRecord('0358f4e4', component.options)
    } else {
      api.reload('0358f4e4', component.options)
    }
    module.hot.accept("./CustomerCreateForm.vue?vue&type=template&id=0358f4e4&", function () {
      api.rerender('0358f4e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerCreateForm.vue"
export default component.exports